import { render, staticRenderFns } from "./ClientRecord.vue?vue&type=template&id=3144dcd2&scoped=true&lang=pug&"
import script from "./ClientRecord.vue?vue&type=script&lang=js&"
export * from "./ClientRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClientRecord.vue?vue&type=style&index=0&id=3144dcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144dcd2",
  null
  
)

export default component.exports